import axios from 'axios'
import axiosRetry from 'axios-retry'
import { deserialize } from 'deserialize-json-api'
import api from '@/plugins/api'

const UserAuthStore = {
  namespaced: true,
  state: () => ({
    currentUserAuth: {
      id: '',
      name: '',
      sites: [],
      masterAccess: '',
      isAdmin: '',
      isClient: ''
    }
  }),
  mutations: {
    setCurrentUserAuth (state, userAuth) {
      state.currentUserAuth = { ...state.currentUserAuth, ...userAuth }
    },
    removeCurrentUserAuth (state) {
      state.currentUserAuth = {
        id: '',
        name: '',
        sites: [],
        masterAccess: '',
        isAdmin: '',
        isClient: ''
      }
    }
  },
  actions: {
    fetchCurrentUserAuth (context) {
      axiosRetry(axios, { retries: 2 })
      return axios.get('/api/current_user_auth_reference').then(
        ({ data }) => {
          const deserializedResponse = deserialize(data)
          context.commit('setCurrentUserAuth', deserializedResponse.data)
        },
        (error) => {
          if (error.response.status === 403) {
            context.commit('errorPage/setForbidden', true, { root: true })
          }

          const payload = {
            status: error.response.status,
            message: `ユーザー情報の取得に失敗しました（${error.response.data.errors.toString()}）`
          }
          context.dispatch('SystemMessageStore/createMessage', payload, {
            root: true
          })
        }
      )
    },
    loggedIn (context) {
      return !!context.state.currentUserAuth.id
    },
    logIn (context, logInData) {
      return new Promise((resolve, reject) => {
        api
          .signIn(logInData)
          .then((response) => {
            const userAuth = deserialize(response.data).data
            context.commit('setCurrentUserAuth', {
              ...userAuth,
              id: userAuth.id,
              name: userAuth.name,
              sites: userAuth.sites,
              masterAccess: userAuth.masterAccess,
              isAdmin: userAuth.isAdminUser,
              isClient: userAuth.isClientUser
            })
            resolve(response)
          })
          .catch((error) => reject(error))
      })
    },
    logOut (context) {
      api.signOut().finally(() => {
        context.commit('removeCurrentUserAuth')
      })
    }
  },
  getters: {
    selectableSites (state) {
      let sites = []
      if (!state.currentUserAuth.sites.length) {
        return sites
      }

      state.currentUserAuth.sites.forEach((site) => {
        sites.push({
          id: site.id,
          siteKey: site.siteKey,
          name: site.name,
          displayName: site.displayName,
          initialDomainWithProtocol: site.initialDomainWithProtocol,
          rootPath: site.rootPath
        })
      })
      return sites
    },
    isAdmin (state) {
      return state.currentUserAuth.masterAccess === 'admin'
    },
    isManager (state) {
      return state.currentUserAuth.masterAccess === 'admin' || state.currentUserAuth.masterAccess === 'manager'
    },
    isWriter (state) {
      return state.currentUserAuth.masterAccess === 'writer'
    },
    isClient (state) {
      return state.currentUserAuth.masterAccess === 'client'
    }
  }
}

export default UserAuthStore
